<template>
    <div class="side-menu-card public font-weight-bold" v-if="showPublic" @click="goPublicClass" >
        <span>Public Class</span>
        <div class="public-menu">
        </div>
    </div>
</template>
<script>
import { getIsOpenClassTeacher,AddTutorClientUsageLog } from '@/api/teachinfo'
import { setCookie, getCookie, clearCookie, urlParamsToObject } from '@/utils/tools'

export default {
    data:()=>({
        showPublic:false
    }),
    mounted(){
        getIsOpenClassTeacher().then(res=>{
            if(res.data.ErrorCode===0 && res.data.Body){
                this.showPublic = res.data.Body
            }
            var client = getCookie("client")
             if (client=="tutorclient"){
                 AddTutorClientUsageLog()
             }
        })
    },
    methods:{
        goPublicClass(){
            this.$router.push({path:'/publicClass'})
        }
    }
}
</script>